import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';

const MODALITY_LABELS = { '01': 'Ambulatorial', '02': 'Hospitalar', '00': 'Não informado' };

export const ProceduresModalityByYear = () => {
    const { chartData } = useProceduresChartsDataContext();

    const modalidadePorAno = chartData?.modalityByYear || {};
    const years = Object.keys(modalidadePorAno).sort();

    const modalitySet = new Set();
    years.forEach((year) => {
        Object.keys(modalidadePorAno[year] || {}).forEach((modality) => modalitySet.add(modality));
    });
    const modalities = Array.from(modalitySet);

    const series = modalities.map((modality) => ({
        name: MODALITY_LABELS[modality] || modality,
        data: years.map((year) => modalidadePorAno[year]?.[modality] ?? 0)
    }));

    return (
        <SimpleBars
            title={'Evolução da Modalidade por Ano'}
            subtitles={years}
            series={series}
            stacked
        />
    );
};
